module.exports = __webpack_public_path__ + "static/img/banner-carousel-20251211-154026.16b48bf.jpg";